import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { EmbedColorListComponent } from './common/components/embed-color-list/embed-color-list.component';
import { EmbedPartControlComponent } from './common/components/embed-part-control/embed-part-control.component';
import { CommonModule } from '@angular/common';
import { EmbedService } from './common/services/embed.service';
import { EmbedData } from '../edit-layout/common/data/embed';
import { Subject, take, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { embedData } from '../../../../components/pages/project-embed/project-embed.data';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { PartModel } from '../workspace-layout/commons/services/project-controller/project-controller';
import { ScreenControlBarComponent } from '../workspace-layout/commons/components/screen-control-bar/screen-control-bar.component';

@Component({
  selector: 'app-embed-layout',
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    EmbedColorListComponent,
    EmbedPartControlComponent,
    ScreenControlBarComponent,
  ],
  templateUrl: './embed-layout.component.html',
  styleUrl: './embed-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmbedLayoutComponent implements OnInit, OnDestroy {
  public isLoading: boolean = true;
  public isStartCustom: boolean = false;

  public selectedProjectIndex: number = 0;

  public isColor: boolean = false;
  public isPart: boolean = false;

  public colorList: Array<string> = [];
  public partList: Array<PartModel> = [];

  public embedUuid: string | undefined;
  public embedData: EmbedData | undefined;

  private unsubscribeAll: Subject<any> = new Subject();
  constructor(
    private threeGraphqlService: ThreeGraphqlService,
    private route: ActivatedRoute,
    private embedService: EmbedService,
    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.getEmbedDataUuid();
    this.embedService.isLoading$.pipe(takeUntil(this.unsubscribeAll)).subscribe((isLoading) => {
      this.isLoading = isLoading;
      this.cd.markForCheck();
    });
    this.getEmbedData();
    this.getSelectedProjectIndex();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public onClickCustom(): void {
    this.embedService.selectedProejct(this.embedData?.projects[0].uuid || '');
    this.isStartCustom = true;
    this.cd.markForCheck();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------

  private getEmbedDataUuid(): void {
    this.route.params.pipe(takeUntil(this.unsubscribeAll)).subscribe((params) => {
      const uuid = params['uuid'];
      if (!uuid) return;

      this.threeGraphqlService
        .getCompanyProjectByUuid(uuid)
        .pipe(take(1))
        .subscribe((embedData: EmbedData | undefined) => {
          if (!embedData) return;
          this.embedService.embedData = embedData;
          this.cd.markForCheck();
        });
    });
  }

  private getEmbedData(): void {
    this.embedService.embedData$.pipe(takeUntil(this.unsubscribeAll)).subscribe((embedData) => {
      if (!embedData) return;
      this.embedData = embedData;
      if (!this.embedData) return;
      if (!this.embedData.projects) return;
      if (!this.embedData.projects[this.selectedProjectIndex]) return;

      this.isColor = this.embedData.projects[this.selectedProjectIndex].setting?.isColor || false;
      this.isPart = this.embedData.projects[this.selectedProjectIndex].setting?.isPart || false;

      this.colorList = this.embedData.projects[this.selectedProjectIndex].colors || [];
      this.partList = this.embedData.projects[this.selectedProjectIndex].partModels || [];

      // this.getEmbedProjectDetailData(this.selectedProjectIndex);

      this.cd.markForCheck();
    });
  }

  private getSelectedProjectIndex(): void {
    this.embedService.selectedProjectIndex$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((index) => {
        this.selectedProjectIndex = index;
        if (!this.embedData) return;
        if (!this.embedData.projects) return;
        if (!this.embedData.projects[this.selectedProjectIndex]) return;
        this.colorList = this.embedData.projects[this.selectedProjectIndex].colors || [];
        this.partList = this.embedData.projects[this.selectedProjectIndex].partModels || [];

        this.getEmbedProjectDetailData(this.selectedProjectIndex);

        this.cd.markForCheck();
      });
  }

  private getEmbedProjectDetailData(index: number): void {
    if (!this.embedData) return;
    if (!this.embedData.projects) return;
    if (!this.embedData.projects[index]) return;
    if (this.embedData.projects[index].baseModels) return;
    this.threeGraphqlService
      .getEmbedProjectByUuid(this.embedData.projects[index].uuid)
      .pipe(take(1))
      .subscribe((embedData: EmbedData | undefined) => {
        if (!embedData) return;
        this.embedData!.projects[index] = embedData;
        this.embedService.embedData = this.embedData;
        this.cd.markForCheck();
      });
  }
}
